import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { settingsItemSx, StyledSwitch } from 'framework/ui/layout';
import useOneStopSettings from 'domain/gpo/oneStop/List/Settings/useOneStopSettings';

const OneStopDescriptionToggler = () => {
  const { setDescriptionsVisible, areDescriptionsVisible } = useOneStopSettings();

  const onChangeCallback = (event: any) => {
    setDescriptionsVisible(event.target.checked);
  };

  return (
    <FormControlLabel
      sx={settingsItemSx}
      control={
        <StyledSwitch
          color="primary"
          onChange={onChangeCallback}
          checked={areDescriptionsVisible}
          dataOn="ON"
          dataOff="OFF"
        />
      }
      label="Show requests descriptions"
    />
  );
};

export default OneStopDescriptionToggler;
